// extracted by mini-css-extract-plugin
export default {"wrapper":"downloadPdf_wrapper__+toI5"};